import React from "react";
import logo from "../../assets/images/branding/territorio-logo-end-rainbow.png";
// frontend/src/assets/images/branding/territoriosvglogoWhite.svg
// frontend/src/assets/images/branding/territorio-logo-endWhite.png

const HeroHome = () => {
  return (
    <section id="home" className="hero-home">
      <img className="hero-home__logo" src={logo} alt="hero image" />
    </section>
  );
};

export default HeroHome;
